import { Table } from 'antd';
import React from 'react'
import { createStyles } from 'antd-style';

const useStyle = createStyles(({ css, token }) => {
  const { antCls } = token;
  return {
    customTable: css`
      ${antCls}-table {
        ${antCls}-table-container {
          ${antCls}-table-body,
          ${antCls}-table-content {
            scrollbar-width: thin;
            scrollbar-color: #eaeaea transparent;
            scrollbar-gutter: stable;
          }
        }
      }
    `,
  };
});

function AntdTable({ columns, dataSource, className, pagination }) {
  const { styles } = useStyle();

  // const enhancedColumns = columns?.filter((col) => (col?.display));
  // OLDER CODE
  // const enhancedColumns = columns?.filter((col) => col?.display).map(col => ({
  //   ...col,
  //   sorter: col.sorter || ((a, b) => (a[col.dataIndex] || '').toString().localeCompare((b[col.dataIndex] || '').toString())),
  // }));

  /* FOLLOWING CODE BLOCK ADDS SORTER TO SUB-CHILDREN COLUMN IN COLUMN MERGE*/
  const filterColumns = (cols) =>
  (cols || [])
    .filter(col => col.display)
    .map(col => ({
      ...col,
      ...(col.children
        ? { children: filterColumns(col.children) }  // Recurse into children
        : {
            sorter:
              col.sorter ||
              ((a, b) =>
                (a[col.dataIndex] || '').toString().localeCompare((b[col.dataIndex] || '').toString())),
          }),
    }));

  const enhancedColumns = filterColumns(columns);

  return <Table
    bordered={false}
    className={`${styles.customTable} ${className} commonTable`}
    dataSource={dataSource}
    columns={enhancedColumns}
    pagination={pagination}
    scroll={{
      x: 'max-content',
      y: dataSource?.length > 5 ? 55 * 5 : undefined,
    }}
  />;
}

export default AntdTable